module.exports = __webpack_public_path__ + "static/media/barcode-read.b81677b5.svg";